import {
  MParticleEventName,
  ProductActionType,
  trackEvent,
} from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { CommonsMParticleListing } from '../../schemas/rql';
import { WatchParentComponentNames } from '@reverbdotcom/commons/src/event_tracking/watchlist';

type Listing = CommonsMParticleListing.Listings;

export function trackRemoveFromCartClick(listing: Listing) {
  if (!listing) return;

  trackEvent({
    eventName: MParticleEventName.ClickedRemoveFromCart,
    listing,
  });
}

export function trackQuantitySelect(listing: Listing) {
  if (!listing) return;

  trackEvent({
    eventName: MParticleEventName.SelectedCartItemQuantity,
    listing,
  });
}

export function trackRemoveFromCart(listing: Listing) {
  if (!listing) return;

  trackEvent({
    eventName: MParticleEventName.RemoveFromCart,
    listing,
    productActionType: ProductActionType.RemoveFromCart,
    source: 'removeFromCart',
  });
}

export function trackMoveToWatchListClick(listing: Listing) {
  if (!listing) return;

  trackEvent({
    eventName: MParticleEventName.AddToWishlist,
    listing,
    productActionType: ProductActionType.AddToWishlist,
    source: 'addToWishlist',
    componentName: WatchParentComponentNames.Cart,
  });

  trackRemoveFromCart(listing);
}
